const getEnv = () => {
  if (process.env) {
    return process.env.REACT_APP_ENV || process.env.NODE_ENV || '';
  }
  return '';
};

const isDevEnv = () => {
  const e = (getEnv() || '').toLowerCase();
  return e === 'development' || e === 'dev' || e === 'local';
};

export const theme = {
  var: (name = 'primary') => `var(--theme-${name})`,
  text: (name = 'primary') => `var(--theme-${name}-contrast)`,
  bg: (name = 'primary', opts = {}) => {
    const { alpha, devOverrideColor } = opts;
    if (devOverrideColor && isDevEnv()) return devOverrideColor;
    return alpha != null
      ? `rgb(var(--theme-${name}-rgb) / ${alpha})`
      : `var(--theme-${name})`;
  },
  border: (name = 'primary', alpha = 1) => `1px solid rgb(var(--theme-${name}-rgb) / ${alpha})`,
};
